import "./AndroidFileBox.scss"
import iconAndroidFile from "../../../assets/svg/fileTypeIcon/ic-android-file.svg"
import {
    RaikoCustomTooltip,
    RaikoLabel,
    RaikoLabelType,
    showDarkMessage,
    showErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {useRef} from "react";
import {RaikoConvertToHumanFileSize} from "../../../raikoComponents/raikoUploader/RaikoConvertToHumanFileSize";

export default function AndroidFileBox({url, title, setTitle, file, setFile}) {
    const inputFile = useRef();

    function handleOnClick() {
        inputFile.current.click()
    }

    function handleSelectFile({target: {files}}) {
        if (typeof files[0] !== 'undefined') {
            // setApkId(-1)
            setFile(files[0])
            setTitle(files[0].name)
        }
    }

    function handleCopyUrl() {
        navigator.clipboard.writeText(url)
            .then(_ => {
                showDarkMessage("لینک فایل کپی شد.")
            }).catch(_ => {
            showErrorMessage("خطا در کپی لینک !")
        })
    }

    return (
        <>
            <div className="baseAndroidFileBoxContainer">
                <img className={file ? "activeImage" : "deActiveImage"} src={iconAndroidFile} alt="androidFile"/>
                <div className={"baseAndroidFileBoxInfoContainer"} onClick={handleOnClick}>
                    <RaikoLabel
                        text={title ? `${title + ` ${file ? `(${RaikoConvertToHumanFileSize(file.size)})` : ""} `}` : "هیچ نسخه ای یافت نشد"}
                        raikoLabelType={RaikoLabelType.TITLE}/>
                    <RaikoLabel text={
                        file ? "برای بارگزاری نسخه جدید بر روی بروزرسانی کلیک نمایید" : "برای انتخاب نسخه ی جدید کلیک نمایید"
                    } raikoLabelType={RaikoLabelType.SUBTITLE}/>

                </div>
                <RaikoCustomTooltip title={"لینک مستقیم نسخه"}>
                    <div onClick={handleCopyUrl} className={`ic-link-file ${url ? "linkIsActive" : "linkIsDeActive"}`}/>
                </RaikoCustomTooltip>
            </div>
            <input
                id='androidFile'
                type="file"
                ref={inputFile}
                hidden
                accept="application/vnd.android.package-archive"
                onChange={handleSelectFile}/>
        </>
    )
}